import client from 'FrontendJsAssets/common/client'
import { formatPrice } from 'FrontendJsAssets/common/format'

export const fetchUserPrices = () => {
    const idsToFetch = []

    for (const fetchPriceEl of document.querySelectorAll('.js-fetch-price')) {
        if (!fetchPriceEl.innerText.includes('...')) continue

        idsToFetch.push(fetchPriceEl.dataset.kid)
    }

    if (!idsToFetch.length) return

    client.post('/zistenie-cien', {
        ids: idsToFetch
    })
    .then((response) => {
        if (!response.data && !response.data.prices) return

        const { prices } = response.data

        for (const kid in prices) {
            for (const fetchPriceEl of document.querySelectorAll(`.js-fetch-price[data-kid="${kid}"]`)) {
                let price = prices[kid].pnv

                if (price) {
                    if (parseFloat(fetchPriceEl.dataset.coef)) {
                        price = price / parseFloat(fetchPriceEl.dataset.coef)
                    }

                    if (parseFloat(fetchPriceEl.dataset.tax)) {
                        price = price * (1 + parseFloat(fetchPriceEl.dataset.tax) / 100)
                    }

                    fetchPriceEl.innerHTML = formatPrice(price)
                } else {
                    fetchPriceEl.innerHTML = fetchPriceEl.dataset.noPricePlaceholder

                    const productId = fetchPriceEl.dataset.id

                    for (const productBuyEl of document.querySelectorAll(`.products__buy:not(:disabled)[data-ec-id="${productId}"]`)) {
                        productBuyEl.disabled = true
                    }
                }
            }

            // vypredaj
            for (const vypredajRibbonEl of document.querySelectorAll(`.js-vypredaj-ribbon[data-kid="${kid}"]`)) {
                vypredajRibbonEl.classList.toggle('hidden', !prices[kid].v)

                const novinkaRibbonEl = vypredajRibbonEl.closest('.js-ribbons-holder').querySelector('.c-ribbon--new')

                // nemoze byt zaroven novinka a vypredaj
                if (prices[kid].v && novinkaRibbonEl) {
                    novinkaRibbonEl.classList.add('hidden')
                }
            }

            // akcia
            for (const actionRibbonEl of document.querySelectorAll(`.js-action-ribbon[data-kid="${kid}"]`)) {
                actionRibbonEl.classList.toggle('hidden', !prices[kid].a)
            }

            // thumb price
            for (const thumbPriceEl of document.querySelectorAll(`.js-product-thumb-price[data-kid="${kid}"]`)) {
                const priceEl = thumbPriceEl.querySelector('.js-actual-price')

                priceEl.classList.toggle('is-action', prices[kid].a)
            }

            // price
            for (const productPriceEl of document.querySelectorAll(`.js-product-price[data-kid="${kid}"]`)) {
                const priceEl = productPriceEl.querySelector('.js-actual-price')

                priceEl.classList.toggle('has-action', prices[kid].a)
            }
        }
    })
    .catch((error) => {
        console.error(error)
    })
}